<template>
  <div>
    <div class="pro-list">
      <el-row>
        <el-col :span="6" class="pp-box" v-for="(item,index) in selfList" :key="index">
          <router-link :to="{path:'/auction/item',query:{id:item.id || item.ID}}" class="pp-simple">
            <div class="image-box" style="background-image: none;"><img :src="item.photo" alt=""></div>
            <div class="info-box-s">
              <h3 class="pm-title">{{item.product_name}}</h3>
              <div class="des" v-if="proDesc"><span class="span">出价<span>{{item.price_count}}</span></span> <span>|</span> <span class="span">围观<span>{{item.look_count}}</span></span> </div>
              <!-- <div class="price">￥{{item.maxprice || item.product_price || 0}}</div> -->
            </div>
            <div class="pm-state" v-if="countdown" :class="time[index]>0?'active':'end'"><span>{{time[index] | formatTimer}}</span></div>
          </router-link>
        </el-col>
      </el-row>
      <div class="page" v-if="page">
        <el-link class="btn-more" :underline="false" disabled v-if="isend">没有更多了</el-link>
        <el-link class="btn-more" :underline="false" @click="getNextPage" v-if="!isend">加载更多</el-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'prolist',
  props: {
    list: {
      type: Array
    },
    //当前时间
    nowtime: {
      type: String,
      default: ''
    },
    //列表是否结束
    isend: {
      type: Boolean,
      default: false
    },
    //是否显示倒计时
    countdown: {
      type: Boolean,
      default: false
    },
    //是否可以获取更多（获取下一页）
    page: {
      type: Boolean,
      default: false
    },
    //是否显示出价信息
    proDesc: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      time: [],
      timer: 0,
      selfList: []
    }
  },
  filters: {
    formatTimer(time) {
      //格式化时间
      function normalize(x) {
        return x < 10 ? '0' + x : x;
      }
      if (time > 0) {
        var h = normalize(time / 3600 | 0);
        var m = normalize(time / 60 % 60 | 0);
        var s = normalize(time % 60);
        return '' + (h + ':' + m + ':' + s);
      } else {
        return '已结束';
      }
    }
  },
  components: {

  },
  methods: {
    //倒计时
    setTimeout() {
      var _this = this;
      // let timer
      _this.timer && clearInterval(_this.timer);
      _this.timer = setInterval(function () {
        let list = _this.time;
        let ret = [];
        list.forEach(function (item) {
          item > 0 ? item-- : '结束';
          ret.push(item);
        });
        _this.time = ret;
      }, 1000);
    },
    getNextPage() {
      let _this = this;
      _this.$emit('nextPageTarget', true)
    },
    //根据作品获取倒计时数组
    handleCountDownTime() {
      let _this = this;
      let ret = [];
      let moment = require("moment");
      let nowtime = moment(_this.nowtime, 'YYYY-MM-DD HH:mm:ss').format('X');
      _this.selfList.forEach(function (item) {
        var overTime = moment(item.end_date, 'YYYY-MM-DD HH:mm:ss').format('X');
        var fromTime = overTime - nowtime;
        ret.push(fromTime);
      });
      _this.time.push.apply(_this.time, ret);
      _this.countdown && _this.setTimeout();
    }
  },
  created() {
    this.$set(this.list)
  },
  watch: {
    'list': {
      handler: function (newVal) {
        let _this = this;
        _this.selfList = newVal;
        _this.handleCountDownTime();
      },
      deep:true
    }
  },
  destroyed() {
    clearInterval(this.timer)
  }
}
</script>
<style lang="scss" scoped>
.pro-list {
  margin-top: 30px;
}
.pp-box {
  padding: 0 10px;
  margin-bottom: 20px;
}
.pp-simple {
  position: relative;
  border-radius: 8px;
  padding: 10px;
  background-color: #fff;
  display: block;
  border: 1px solid #fff;
  &:hover {
    border: 1px solid #eee;
  }
  .image-box {
    padding-top: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 200px auto;
    position: relative;
    overflow: hidden;
    img {
      width: 100%;
      transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      position: absolute;
      top: 50%;
      left: 50%;
    }
  }
  .pm-state {
    font-size: 18px;
    line-height: 18px;
    color: #fff;
    position: absolute;
    top: -4px;
    left: -4px;
    width: 100px;
    height: 100px;
    background-repeat: no-repeat;
    background-position: 100% center;
    background-size: contain;
    z-index: 99;
    > span {
      transform: rotate(-45deg) translate(-50%, -50%);
      transform-origin: left;
      width: 100%;
      display: block;
      text-align: center;
      position: absolute;
      left: 50%;
      top: 39%;
    }
  }
  .pm-state.active {
    background-image: url(../assets/image/active.png);
  }

  .pm-state.end {
    background-image: url(../assets/image/end.png);
  }
  .info-box-s {
    margin-top: 10px;
    .pm-title {
      font-size: 16px;
      line-height: 32px;
      color: #333;
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &:hover {
        color: #cfa972;
      }
      > span {
        font-size: 18px;
        line-height: 32px;
        font-weight: 500;
        display: inline-block;
        vertical-align: middle;
        color: #333;
      }
    }
    .des {
      font-size: 14px;
      line-height: 32px;
      color: #333;
      .span {
        color: #999;
        margin-right: 5px;
        display: inline-block;
        vertical-align: middle;
        > span {
          margin-left: 5px;
          color: #333;
        }
      }
    }
    .price {
      font-size: 20px;
      line-height: 32px;
      color: #de3f34;
      font-weight: bold;
    }
  }
}
</style>